import { tableMappingAPI } from '../components/Table/utils';
import { CUSTOM_ATTR } from '../constants/constant';
import {
	appendTimePeriodPrefix,
	appendTimePeriodPrefixDirect,
	formatName,
} from './helper';
import { v4 as uuid4 } from 'uuid';

// This transform the nested graphql response to a flat array of result objects
// It also returns a single row of total data object
export const transformGraphQLResponse = (
	graphqlResponse,
	channel,
	weekFilter,
	timePeriods,
	viewBy,
	breakdownBy
) => {
	const results = {
		rowData: [],
		totalRow: [],
	};

	if (!graphqlResponse) {
		return results;
	}

	const defaultMetrics = tableMappingAPI(channel);

	// This function is used to check in which case we need to expand the Item rows
	const itemExpansionCondition = (level) => {
		// Check if the table row level is Item
		if (level === 'ITEM') {
			// Enable Item Expansion only when the Global Channel Filter is Store and Viewby is Item and Breakdown by either State or Store
			if (
				channel === 'Store' &&
				viewBy === 'ITEM' &&
				(breakdownBy === 'STATE' || breakdownBy === 'STORE')
			) {
				return true;
			} else {
				return false;
			}
		} else if (
			level === 'STATE' &&
			viewBy === 'ITEM' &&
			breakdownBy === 'STATE'
		) {
			return false;
		} else if (
			level === 'STORE' &&
			viewBy === 'ITEM' &&
			(breakdownBy === 'STATE' || breakdownBy === 'STORE')
		) {
			return false;
		} else {
			return true;
		}
	};

	graphqlResponse?.map((tableRow, index) => {
		const tableRowLevel =
			tableRow?.type === CUSTOM_ATTR
				? tableRow?.customAttrLevel
				: tableRow?.wmtAttrLevel;
		const attrLevel =
			tableRow?.type === CUSTOM_ATTR
				? tableRow?.customAttrLevel
				: tableRow?.wmtAttrLevel;
		// If the GraphQL response has more than 1 object
		if (graphqlResponse?.length > 1) {
			if (tableRow?.id && tableRow?.name?.toLocaleLowerCase() !== 'total') {
				results.rowData[index] = {
					id: tableRow?.id,
					name: tableRow?.name?.toLocaleLowerCase() || '',
					description: formatName(tableRow, tableRowLevel, tableRow?.type),
					level: tableRowLevel,
					group: itemExpansionCondition(tableRowLevel),
					upcNbr: tableRow?.upcNbr,
					catalogItemId: tableRow?.catalogItemId,
					primeItemNbr: tableRow?.primeItemNbr,
		            allLinkNbr: tableRow?.allLinkNbr,
					wmtItemNo: attrLevel === 'ITEM' ? tableRow?.id : '-',
					fullWidth: false,
					totalRows: tableRow?.totalRow,
					hierarchyLevel: tableRow?.hierarchyLevel,
					sort: tableRow?.sort,
					rootParam: tableRow?.roots,
					type: tableRow?.type,
					standardName: tableRow?.name,
				};
				for (const metric in defaultMetrics) {
					const columns = Object.keys(defaultMetrics[metric]);
					const tableRows = Object.keys(tableRow);
					for (const column of columns) {
						if (tableRows?.includes(column)) {
							if (Array.isArray(tableRow[column])) {
								results.rowData[index] = {
									...results?.rowData[index],
									...tableRow[column][0],
								};
							}
						}
					}
				}
				// Helper Function to Append Time Period Prefix to Keys Based on Week Filter // e.g.: WTD_, LW_, L4W_ ....
				results.rowData[index] = appendTimePeriodPrefix(
					results.rowData[index],
					weekFilter
				);

				// Iterate over time periods and append to results object
				timePeriods?.map((tp, tp_index) => {
					const compareObject = {
						compareData: [],
					};

					let newTpValue = null;

					// Extract data from GraphQL Response based on time period sequence
					for (const metric in defaultMetrics) {
						const columns = Object.keys(defaultMetrics[metric]);
						const tableRows = Object.keys(tableRow);
						for (const column of columns) {
							if (tableRows?.includes(column)) {
								if (Array.isArray(tableRow[column])) {
									compareObject.compareData[index] = {
										...compareObject?.compareData[index],
										...tableRow[column][tp_index + 1],
									};
									// DSIDVL-39585 adding guard duration type check to render correct mapping for each column in tablerow
									if (tableRow[column][tp_index + 1]?.durationType) {
										newTpValue = tableRow[column][tp_index + 1]?.durationType;
									}
								}
							}
						}
					}

					// Adding prefix for specific compared time period object
					if (newTpValue) {
						compareObject.compareData[index] = appendTimePeriodPrefixDirect(
							compareObject.compareData[index],
							newTpValue
						);
					}

					results.rowData[index] = {
						...results.rowData[index],
						...compareObject.compareData[index], // To be replaced with modifiedResults object
					};
				});

				// Remove null from the rowData array
				//results.rowData = results.rowData.filter((row) => row);
			} else {
				let total = {
					name: 'Total',
					description: 'Total',
					fullWidth: false,
					totalRows: null,
					hierarchyLevel: null,
					sort: null,
				};

				for (const metric in defaultMetrics) {
					const columns = Object.keys(defaultMetrics[metric]);
					const tableRows = Object.keys(tableRow);
					for (const column of columns) {
						if (tableRows?.includes(column)) {
							if (Array.isArray(tableRow[column])) {
								total = {
									...total,
									...tableRow[column][0],
								};
							}
						}
					}
				}
				// Helper Function to Append Time Period Prefix to Keys Based on Week Filter // e.g.: WTD_, LW_, L4W_ ....
				total = appendTimePeriodPrefix(total, weekFilter);
				// Iterate over time periods and append to results object
				timePeriods?.map((tp, tp_index) => {
					const compareObject = {
						compareData: [],
					};

					let newTpValue = null;
					// Extract data from GraphQL Response based on time period sequence
					for (const metric in defaultMetrics) {
						const columns = Object.keys(defaultMetrics[metric]);
						const tableRows = Object.keys(tableRow);
						for (const column of columns) {
							if (tableRows?.includes(column)) {
								if (Array.isArray(tableRow[column])) {
									compareObject.compareData[index] = {
										...compareObject?.compareData[index],
										...tableRow[column][tp_index + 1],
									};
									newTpValue = tableRow[column][tp_index + 1]?.durationType;
								}
							}
						}
					}

					// Adding prefix for specific compared time period object
					if (newTpValue) {
						compareObject.compareData[index] = appendTimePeriodPrefixDirect(
							compareObject.compareData[index],
							newTpValue
						);
					}

					total = {
						...total,
						...compareObject.compareData[index],
					};
				});
				results.totalRow.push(total);
			}
		} else {
			// Else, Create an empty row (Filled with dashes), Because no data rows returned from GraphQL.
			let emptyRow = {
				name: '-',
				description: '-',
				fullWidth: false,
				totalRows: tableRow?.totalRow,
				hierarchyLevel: tableRow?.hierarchyLevel,
				sort: tableRow?.sort,
			};
			results.rowData.push(emptyRow);
		}
	});
	return results;
};

export const clientRequestID = () => uuid4();

export const apolloHeaders = (operationName) => {
	if (!operationName) {
		throw new Error('Operation name is required');
	}

	return {
		'X-APOLLO-OPERATION-NAME': operationName,
		'x-app-id': 'CHANNELPERFORMANCE_INSIGHTS',
	};
};
